import { initGallerySlider } from "./components/sliders";
import initGalleryModal from "./components/modalSliders";
import initFacets from "./components/facets";
import initAnimations from "./components/animations";

function runOnLoadAndDocumentReady() {
  initGallerySlider();
  initGalleryModal();
  initFacets();
  initAnimations();
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();
